import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { adminPath } from "../../helpers/adminRoles";

// Server caps the page size at 20; keep the client in step with it.
const SEARCH_LIMIT = 20;
// Long enough to skip the intermediate keystrokes of "sand", short enough to
// still feel instant.
const SEARCH_DEBOUNCE_MS = 400;

export default class ViewProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      searchString: "",
      pageNumber: 1,
      currentProducts: [],
      productsView: [],
      loadshow: "load_sec collapse-hide",
      tableArray: [],
      datatableProps: {},
      isLoading: false,
      // Set only by the "search anywhere in the name" action; reset on every
      // new keystroke so normal typing always uses the fast indexed search.
      deepSearch: false,
    };
    this.deleteproductRequest = this.deleteproductRequest.bind(this);
    this.fetchpagesdata = this.fetchpagesdata.bind(this);
    // Monotonic id of the newest search; older responses are discarded so a
    // slow "sand" reply can never overwrite the newer "sande" results.
    this.searchRequestId = 0;
  }

  // To get detais after first render
  componentDidMount = () => {
    this.fetchpagesdata();
  };

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  }

  //  For getting the data with pagination and search
  fetchpagesdata() {
    let searched = this.state.searchString;
    let pageNumber = this.state.pageNumber;
    let limit = SEARCH_LIMIT;
    let offset = (pageNumber - 1) * limit;
    const requestId = ++this.searchRequestId;

    this.state.isLoading = true;
    this.state.datatableProps = {};
    this.forceUpdate();

    Httpconfig.httptokenpost(Constant.siteurl + "api/productsMaster/", {
      search: searched,
      page: pageNumber,
      limit: limit,
      offset: offset,
      // Only set by the explicit "search anywhere in the name" action - it
      // makes the server fall back to a full-catalogue substring scan.
      deep_search: this.state.deepSearch === true,
    })
      .then((response) => {
        // A newer search already went out - this reply is stale, drop it.
        if (requestId !== this.searchRequestId) return;

        const data = response.data.data || [];
        this.state.currentProducts = data;

        this.state.loadshow =
          data.length >= SEARCH_LIMIT
            ? "load_sec collapse-show"
            : "load_sec collapse-hide";

        const productsView = data.map((item, num) => {
          return {
            SINO: num + 1,
            medicineid: item.medicineid,
            medicine_name: item.medicinename,
            medicine_main: item.manufacturer,
            medicine_type: item.form,
            medicine_strength: item.strength,
            medicine_size: item.size,
            mrp: item.mrp,
            image:
              item.image != null ? (
                <img
                  src={item.image}
                  style={{ width: "50px", height: "50px" }}
                  alt="product"
                />
              ) : (
                <img
                  src="../images/retailer/no-product.png"
                  style={{ width: "50px", height: "50px" }}
                  alt="no product"
                />
              ),
            actions: (
              <div>
                <span>
                  <i
                    onClick={() => this.editProducts(item.id)}
                    className="fa fa-edit point-cursor"
                    title={"Edit"}
                  ></i>
                </span>{" "}
                &nbsp;
                <span>
                  <i
                    onClick={() => this.uploadImage(item.id)}
                    className="fa fa-upload point-cursor"
                    title={"Upload Image"}
                  ></i>
                </span>{" "}
                &nbsp;
                <span>
                  <i
                    onClick={() =>
                      this.deleteproductRequest(item.id, item.medicinename)
                    }
                    className="fa fa-trash point-cursor"
                    title={"Delete"}
                  ></i>
                </span>{" "}
                &nbsp;
              </div>
            ),
          };
        });

        this.state.productsView = productsView;

        if (pageNumber === 1) {
          this.state.tableArray = [...productsView];
        } else {
          productsView.forEach((element) => {
            this.state.tableArray.push(element);
          });
        }

        this.setDataTable(this.state.tableArray);
        this.state.isLoading = false;
        this.forceUpdate();
      })
      .catch((error) => {
        if (requestId !== this.searchRequestId) return;
        this.state.isLoading = false;
        this.forceUpdate();
        console.error(error);
      });
  }

  // Setting data table data
  setDataTable = (tableData) => {
    const datatable = {
      columns: [
        {
          label: "Medicine ID",
          field: "medicineid",
          sort: "asc",
          width: 150,
        },
        {
          label: "Name",
          field: "medicine_name",
          sort: "asc",
          width: 150,
        },
        {
          label: "Manufacturer",
          field: "medicine_main",
          sort: "asc",
          width: 150,
        },
        {
          label: "Type",
          field: "medicine_type",
          sort: "asc",
          width: 150,
        },
        {
          label: "Strength",
          field: "medicine_strength",
          sort: "asc",
          width: 150,
        },
        {
          label: "UOM",
          field: "medicine_size",
          sort: "asc",
          width: 150,
        },
        {
          label: "MRP",
          field: "mrp",
          sort: "asc",
          width: 150,
        },
        {
          label: "Image",
          field: "image",
          sort: "asc",
          width: 150,
        },
        {
          label: "Actions",
          field: "actions",
          sort: "asc",
          width: 10,
        },
      ],
      rows: tableData,
    };
    this.state.datatableProps = {
      columns: [
        {
          label: "S.No",
          field: "SINO",
        },
        ...datatable.columns,
      ],
      rows: [
        ...datatable.rows.map((item, index) => {
          item.SINO = index + 1;
          return item;
        }),
      ],
    };
  };

  // Handle searched string, debounced so we fire one query per pause in typing
  handleSearchedString = (event) => {
    const value = event.target.value;
    this.state.pageNumber = 1;
    this.state.searchString = value;
    this.state.deepSearch = false;

    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.fetchpagesdata();
    }, SEARCH_DEBOUNCE_MS);

    this.forceUpdate();
  };

  // Retry the current term as a substring search across the whole catalogue
  handleDeepSearch = (event) => {
    event.preventDefault();
    this.state.deepSearch = true;
    this.state.pageNumber = 1;
    this.fetchpagesdata();
  };

  // Handle clear search
  handleClear = (id) => {
    // Drop any debounced keystroke still waiting, so it cannot re-run the
    // cleared search after this fetch.
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.state.deepSearch = false;
    if (id == "input-search") {
      this.state.pageNumber = 1;
      this.state.searchString = "";
      document.getElementById(id).value = "";
    }
    this.forceUpdate();
    this.fetchpagesdata();
  };

  // Handle scroll for load more
  handleScroll(e) {
    let page = this.state.pageNumber;
    page = page + 1;
    this.state.pageNumber = page;
    this.fetchpagesdata();
  }
  // Redirect to image upload page
  uploadImage(id) {
    this.props.history.push(adminPath("UploadImages/" + id));
  }

  // editProducts
  editProducts(id) {
    this.props.history.push(adminPath("editProducts/" + id));
  }

  //delete controller
  deleteproductRequest(Id, name) {
    var isConfirm = window.confirm("Are you sure to delete " + name + "?");

    if (isConfirm) {
      Httpconfig.httptokendelete(Constant.siteurl + "api/productsMaster/" + Id)
        .then((response) => {
          if (response.data.status == 200 && !response.data.error) {
            toast.success(response.data.message);
            this.state.pageNumber = 1;
            this.state.searchString = "";
            this.fetchpagesdata();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  render() {
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link>&gt;Order Medicine &gt;
                      View Products
                    </li>
                  </ol>
                </div>
              </div>

              <div id="search_order">
                <div className="">
                  <div className="row">
                    <div className="col-md-10">
                      <form>
                        <div className="form-group">
                          <label>Search Product</label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="input-search"
                              className="form-control"
                              placeholder="Search by Medicine ID, Name, Manufacturer or Type"
                              onChange={this.handleSearchedString}
                            />
                            <img
                              style={{ cursor: "pointer" }}
                              className="remove_icon"
                              src="../images/patient/img/Ordermedicine/delete.png"
                              onClick={this.handleClear.bind(
                                this,
                                "input-search"
                              )}
                            />
                            <div className="input-group-btn"></div>
                          </div>
                          <div
                            className="col-md-2 download_btn"
                          >
                            <Link
                              to="/admin/editProducts"
                              className="btn btn-primary"
                              style={{ alignContent: "center" }}
                            >
                              Create Product
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 no_padding">
                        <div id="reg_form">
                          <div className="table-responsive dataTables_wrapper load_sec">
                            {this.state.isLoading && (
                              <div style={{ textAlign: "center", padding: "30px 0" }}>
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                  style={{ width: "2rem", height: "2rem" }}
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                                <p style={{ marginTop: 8, color: "#555" }}>Searching products...</p>
                              </div>
                            )}
                            {!this.state.isLoading && this.state.datatableProps.rows &&
                            this.state.datatableProps.rows.length > 0 ? (
                              <MDBDataTable
                                striped
                                responsive
                                bordered
                                paging={false}
                                searching={false}
                                data={this.state.datatableProps}
                              />
                            ) : !this.state.isLoading ? (
                              <div style={{ textAlign: "center", padding: "40px 0", color: "#666" }}>
                                <i
                                  className="fa fa-search"
                                  style={{ fontSize: 36, marginBottom: 12, color: "#ccc" }}
                                ></i>
                                <p style={{ fontSize: 16, marginBottom: 4 }}>
                                  {this.state.searchString
                                    ? `No products found for "${this.state.searchString}"`
                                    : "No products found"}
                                </p>
                                {this.state.searchString && (
                                  <p style={{ fontSize: 13, color: "#999" }}>
                                    Try a different Medicine ID, name, manufacturer or type
                                  </p>
                                )}
                                {this.state.searchString && !this.state.deepSearch && (
                                  <p style={{ fontSize: 13 }}>
                                    <a
                                      href="#"
                                      onClick={this.handleDeepSearch}
                                      style={{ color: "#00b3c6" }}
                                    >
                                      Search anywhere in these fields
                                    </a>{" "}
                                    <span style={{ color: "#999" }}>
                                      (slower - scans the full catalogue)
                                    </span>
                                  </p>
                                )}
                              </div>
                            ) : null}

                            {this.state.productsView &&
                            this.state.productsView.length > 0 ? (
                              <div
                                className={this.state.loadshow}
                                onClick={this.handleScroll.bind(this)}
                              >
                                <a id="loadMore">
                                  Load More....{" "}
                                  <img src="https://static.thenounproject.com/png/427197-200.png" />
                                </a>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button onClick="topFunction()" id="myBtn" title="Go to top">
                  <img src="https://i.pinimg.com/originals/c4/f0/4b/c4f04b83f93836a05b4f188180708e0e.png" />
                </button>
              </section>
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
    );
  }
}
